<template>
    <header class="position-relative">
        <dicta-header :englishSupported="true"></dicta-header>
        <div class="bg-primary second-header d-flex position-relative align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-5 col-sm-5 col-8">
                        <router-link to="/">
                            <div class="logo-div">
                                <div
                                    class="logo-wrap bg-white d-flex align-items-center rounded-circle justify-content-center">
                                    <img src="@/assets/logo.png" alt="logo" />
                                </div>
                                <div class="d-inline-block  text-white mx-2">
                                    <div class="tool-name">{{ hebrew ? 'איתור אזכורים' : 'Citation Finder' }}</div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-4 pt-1 text-left d-block d-sm-none">
                        <mobile-menu class="mt-1 text-body" @showHowDialog="showAbout = true" :howDialog="true">
                        </mobile-menu>
                    </div>
                    <div class="col-lg-5 col-md-7 col-sm-7">
                        <div class="d-flex align-items-center h-100 justify-content-end">
                            <b-button id="about-btn" variant="primary"
                                class="btn-outline-light px-3 d-none d-sm-inline-block py-1" @click="showAbout = true">
                                {{ hebrew ? 'איך זה עובד' : 'How it works' }}
                            </b-button>
                        </div>
                        <about-dialog v-model="showAbout"></about-dialog>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import AboutDialog from "@/components/aboutDialog"

export default {
    name: "Header",
    components: {
        AboutDialog,
    },
    data() {
        return {
            showAbout: false,
        }
    },
    computed: {
        hebrew() {
            return this.$settings.hebrew
        }
    }
}
</script>
<style scoped lang="scss">
header {
    @media only screen and (max-width: 676px) {
        z-index: 9;
    }
}
.second-header {
    box-shadow: 2px 2px 4px 0 rgb(0 0 0 / 32%);
    z-index: 1;
    height: 50px;
}

.logo-div {
    display: flex;
    align-items: center;
}

.logo-wrap {
    width: 36px;
    height: 36px;


    img {
        max-width: 100%;
        max-height: 100%;
    }
}
</style>
  